/* eslint-disable no-magic-numbers -- surface tokens are named by number */

import styled from 'styled-components';

export const ShortcutsList = styled.ol`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 20px 0 0;
  margin: 0;
  list-style: none;
  justify-content: center;
  align-items: flex-start;
`;

export const Shortcut = styled.li`
  color: ${props => props.theme.text.primary};
  cursor: pointer;
  font-weight: 400;
  padding: 2px 10px;
  &:hover {
    background-color: ${props => props.theme.surface[4]};
    border-radius: 16px;
  }
`;
